import Reflux from "reflux";
import createReactClass from "create-react-class";

import Button from "@javascript/reactComponents/lds/Button";
import Container from "@javascript/reactComponents/lds/Container";
import FacetSearchStore from "@javascript/stores/facetSearchStore";

import Heading from "@javascript/reactComponents/lds/typography/Heading";
import NO_RESULTS_FOUND_SVG from "@images/no-results-found.svg";
import { timeFrameInWords } from "@javascript/helpers/dateTimeUtilities";

const NoEventsFound = createReactClass({
  mixins: [Reflux.connect(FacetSearchStore, "facetSearch")],

  getInitialState() {
    return {
      facetSearch: FacetSearchStore.data,
      isSearching: false,
      originalTimeFrame: null,
    };
  },


  componentDidUpdate(prevProps, prevState) {
    if (this.state.isSearching) {
      const prevTotalCount = prevState.facetSearch.total_count;
      const currentTotalCount = this.state.facetSearch.total_count;

      if (prevTotalCount !== currentTotalCount) {
        this.setState({
          isSearching: false,
          originalTimeFrame: null,
        });
      }
    }
  },

  trackEntityClick(entityType, entityName) {
    return () => {
      Zymewire.external_track_action("No Events Found - Entity Click", {
        entity_type_ref: entityType,
        entity_name: entityName,
      });

      const url = `/sales_assistant/${entityType}/lookup?entity_name=${entityName}`;
      window.open(url, "_blank");
    };
  },

  handleTimeReset() {
    const currentTimeFrame = this.state.facetSearch.timeFrame;

    this.setState({
      isSearching: true,
      originalTimeFrame: currentTimeFrame,
    });

    if (window.reset_time_select) {
      window.reset_time_select();
    }

    return false;
  },

  renderEntityCtas() {
    const { filterCriteria } = this.state.facetSearch;
    if (!filterCriteria) return null;

    const entities = Object.entries(filterCriteria).flatMap(([entityType, entityValues]) => {
      if (!entityValues || !entityValues.length) return [];

      return entityValues.map(entityValue => ({
        type: entityType,
        value: entityValue
      }));
    });

    if (entities.length === 0) return null;

    const typeToIcon = {
      conditions: "variable",
      organizations: "company",
      therapies: "entity",
      medical_technologies: "entity",
      pharma_ingredients: "entity",
      trials: "entity",
    };

    const profileText = entities.length > 1 ? "profiles" : "profile";

    return (
      <Container className="no-events-found-entity-section">
        <p>Based on your search, the following {profileText} may be helpful and will open in a new tab:</p>
        <div
          className="no-events-found-entity-buttons-container"
          ref={(el) => { this.buttonContainerRef = el; }}
        >
          {entities.map((entity, index) => (
            <Button
              className=""
              icon={typeToIcon[entity.type] || "variable"}
              key={`${entity.type}-${index}`}
              onClick={this.trackEntityClick(entity.type, entity.value)}
              size="medium"
              variant="primary"
            >
              {`View ${entity.value} Profile`}
            </Button>
          ))}
        </div>
      </Container>
    );
  },

  renderNoEntitiesMessage() {
    const { filterCriteria, timeFrame } = this.state.facetSearch;

    const hasEntities = filterCriteria && Object.values(filterCriteria).some(
      values => values && values.length > 0
    );

    if (!hasEntities && (!timeFrame || timeFrame.selected === "time_any")) {
      return (
        <Heading
          size="h3"
        >
          Try adjusting filters or keywords to broaden your search.
        </Heading>
      );
    }

    return null;
  },

  renderTimeAndMessage() {
    const timeFrame = this.state.isSearching && this.state.originalTimeFrame
      ? this.state.originalTimeFrame
      : this.state.facetSearch.timeFrame;

    if (!timeFrame || timeFrame.selected === "time_any") {
      return (
        <Heading size="h3">
          No events found based on your current search criteria.
        </Heading>
      );
    }

    const timeFrameData = this.state.isSearching && this.state.originalTimeFrame
      ? this.state.originalTimeFrame
      : FacetSearchStore.getActiveTimeFrame();

    let timeFrameDescription = timeFrameInWords(timeFrameData);

    return (
      <Heading size="h3">
        No events found {timeFrameDescription}.{" "}
        <a
          className="lds-text-link"
          onClick={this.handleTimeReset}
        >
          Search All Time
        </a>
      </Heading>
    );
  },

  render() {

    if (!this.state?.facetSearch || this.state.facetSearch.total_count !== 0) {
      return null;
    }

    return (
      <Container
        className="no-events-found-container"
      >
        <div className="no-events-found-hero">
          <img
            alt="No events found"
            className="no-events-found-image"
            src={NO_RESULTS_FOUND_SVG}
          />

          {this.renderTimeAndMessage()}

          {this.renderNoEntitiesMessage()}
        </div>

        {this.renderEntityCtas()}
      </Container>
    );
  },
});

window.NoEventsFound = NoEventsFound;
export default NoEventsFound;
